import { Pipe, PipeTransform } from '@angular/core';
import * as common from '../../common';
import { MatchEvent } from '../../models';
/*
 * Formats seconds as time
 * Takes an integer argument that defaults to 0.
 * Usage:
 *   value | event: index
 * Example:
 *   {{ 2 | event: 9 }}
 *   formats to: #9 00:00:02
*/
@Pipe({ name: 'event', pure: false })
export class FormatEventPipe implements PipeTransform {
  transform(matchEvent: MatchEvent, eventIndex?: any): string {
    const formattedTime = common.secondsToTime(matchEvent.seconds);
    let prefix = (eventIndex) ? `#${eventIndex} ` : `#0 `;

    prefix = `${prefix}${formattedTime}`;

    if (matchEvent.comments && matchEvent.comments.trim().length > 0) {
      prefix = `${prefix} ${matchEvent.comments}`;
    }

    if (matchEvent.tags && matchEvent.tags.length > 0) {
      prefix = `${prefix} #${matchEvent.tags[0]}`;
    }

    return prefix;
  }
}

/*
 * Formats seconds as time
 * Takes an integer argument that defaults to 0.
 * Usage:
 *   value | time
 * Example:
 *   {{ 2 | time }}
 *   formats to: 00:00:02
*/
@Pipe({ name: 'time' })
export class FormatTimePipe implements PipeTransform {
  transform(value): string {
    const formattedTime = common.secondsToTime(value);
    return formattedTime;
  }
}

